import React, {useState} from 'react';
import * as moment from 'moment';
import StampSubmitterForm from '../../organisms/stamp-submitter-form';
import Transition from '../../../utils/transition';
import Http from '../../../http';
import ErrorHandler from '../../../utils/error-handler';
import {connect} from "react-redux";
import { toast } from 'react-toastify';
import { setStampSubmitter } from "../../../redux/modules/user";
import PreSettingDone from '../../templates/pre-setting-done';
import {UrlUtil} from "@graffer-inc/graffer-ui";

const format2Digit = value => String(value).length === 1 ? `0${String(value)}` : String(value);

const Main = ({setStampSubmitter, stampSubmitter}) => {
  const [isRequesting, setIsRequesting] = useState(false);
  const { to } = UrlUtil.parseQueryOf(window.location.search);
  const updateStampSubmitter = async (formData) => {
    setIsRequesting(true);
    const convertedBirthday = `${formData.birthday.year}-${format2Digit(formData.birthday.month)}-${format2Digit(formData.birthday.day)}T00:00:00.000Z`;
    const body = {
      name: formData.name,
      qualification: formData.qualification === 'その他' ? formData.otherQualification : formData.qualification,
      birthday: convertedBirthday,
      typeOfCalendar: formData.typeOfCalendar,
    };
    await Http.updateStampSubmitter(
      body,
      res => {
        setIsRequesting(false);
        toast.success('印鑑提出者情報を変更しました。');
        setStampSubmitter(res.data.stampSubmitter);
        Transition.goTo(to || '/home');
      },
      e => {
        setIsRequesting(false);
        ErrorHandler.common(e.response.status);
      },
    )
  };
  return (
    <PreSettingDone>
      <div className="container">
        <div className="columns is-centered">
          <div className="column is-7">
            <p className="is-size-3 has-text-weight-bold">印鑑提出者設定の変更</p>
            <p className="is-size-7">あなたの所属する法人の印鑑提出者の情報はすでに登録されています。誤りがある場合、変更してください。</p>
            <p className="is-size-7">代表印の印鑑登録の申請時に
              <a href="http://houmukyoku.moj.go.jp/homu/content/001188212.pdf" target="_blank" rel="noopener noreferrer">
                印鑑届書
              </a>
              に記載した内容を入力してください。</p>
            <br/>
            {
              stampSubmitter && (
                <StampSubmitterForm
                  initialFormData={{
                    name: stampSubmitter.name,
                    birthday: {
                      year: moment(stampSubmitter.birthday).format('YYYY'),
                      month: moment(stampSubmitter.birthday).format('M'),
                      day: moment(stampSubmitter.birthday).format('D'),
                    },
                    qualification: ['代表取締役', '取締役', '代表理事'].includes(stampSubmitter.qualification) ? stampSubmitter.qualification : 'その他',
                    otherQualification: ['代表取締役', '取締役', '代表理事'].includes(stampSubmitter.qualification) ? '' : stampSubmitter.qualification,
                    typeOfCalendar: stampSubmitter.typeOfCalendar,
                  }}
                  onSubmit={v => updateStampSubmitter(v)}
                  isRequesting={isRequesting}
                  isEdit
                />
              )
            }
          </div>
        </div>
      </div>
    </PreSettingDone>
  )
};

export default connect(
  store => ({ stampSubmitter: store.user.stampSubmitter }),
  {setStampSubmitter}
)(Main);